/* eslint-disable max-classes-per-file */
import { getAuthenticationHeader } from '@fenderdigital/custom-hooks/lib/cognito';
import fetch from '../core/fetch';
import Cookie from './cookie';

export const parsePromoCode = code => {
  if (code && typeof code == 'string') {
    return code.toLowerCase();
  }
  return code;
};
export class SubscriptionNotFound extends Error {
  constructor() {
    super('Subscription Not Found');
    this.name = 'SubscriptionNotFound';
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, SubscriptionNotFound);
    }
  }
}

const clientName = process.env.REACT_APP_CLIENT_SITE_ID || 'play';

export default class Subscriptions {
  static async redeem(attributes) {
    const utm = Cookie.getUtms();
    const clickref = Cookie.getClickRef();
    const affiliateId = Cookie.getAffiliateId();
    const {
      firstName,
      lastName,
      userID,
      redemptionCode,
      playSubscriptionStatus,
      email,
      city,
      state,
      country,
      postal,
    } = attributes;
    const countryCode = Cookie.getCountry() || country;
    let url = `${process.env.REACT_APP_CLIENT_FC_SUBSCRIPTIONS_API}/prepaid/subscriptions/renew`;
    const transactionData = {
      'user-id': userID,
      'redemption-code': redemptionCode,
      'first-name': firstName,
      'last-name': lastName,
      email,
      city,
      state,
      country: countryCode,
      postal,
      'utm-campaign': utm.utm_campaign,
      'utm-medium': utm.utm_medium,
      'utm-source': utm.utm_source,
      clickref,
      'affiliate-id': affiliateId,
    };
    if (!playSubscriptionStatus || playSubscriptionStatus === 'unsubscribed') {
      url = `${process.env.REACT_APP_CLIENT_FC_SUBSCRIPTIONS_API}/prepaid/subscriptions`;
    }
    const token = await getAuthenticationHeader(true);
    const params = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-Client-Name': clientName,
      },
      body: JSON.stringify(transactionData),
    };
    const response = await fetch(url, params);
    return response;
  }

  static async validatePromoCode(promoCode) {
    const parsedCode = parsePromoCode(promoCode);
    const url = `${process.env.REACT_APP_CLIENT_FC_SUBSCRIPTIONS_API}/promos/${parsedCode}/validate`;
    const token = await getAuthenticationHeader(true);
    const method = 'GET';
    const params = {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-Client-Name': clientName,
      },
    };
    const response = await fetch(url, params);
    return response;
  }

  static async validate(promoCode) {
    const url = `${process.env.REACT_APP_CLIENT_FC_SUBSCRIPTIONS_API}/prepaid/code/${promoCode}`;
    const token = await getAuthenticationHeader(true);
    const method = 'GET';

    const params = {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-Client-Name': clientName,
      },
    };
    const response = await fetch(url, params);
    return response;
  }

  static async getAccountSummary(userID) {
    const url = `${process.env.REACT_APP_CLIENT_FC_SUBSCRIPTIONS_API}/subscriptions/summary?user-id=${userID}`;
    const token = await getAuthenticationHeader(true);
    const params = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Client-Name': clientName,
      },
    };

    const response = await fetch(url, params);
    const payload = await response.json();
    if (response.status >= 200 && response.status < 300) {
      return payload;
    } else if (response.status === 404) {
      throw new SubscriptionNotFound();
    }
    const error = new Error(JSON.stringify(payload));
    error.code = response.status;
    throw error;
  }

  static async getCityState(zipCode, countryCode = 'US') {
    // eslint-disable-next-line max-len
    const url = `${process.env.REACT_APP_CLIENT_FC_SUBSCRIPTIONS_API}/subscriptions/location?zipcode=${zipCode}&country=${countryCode}`;
    const token = await getAuthenticationHeader(true);
    const method = 'GET';

    const params = {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-Client-Name': clientName,
      },
    };
    const response = await fetch(url, params);
    return response;
  }
}
